import { render, staticRenderFns } from "./ManageOrderItems.vue?vue&type=template&id=6942a138"
import script from "./ManageOrderItems.vue?vue&type=script&lang=js"
export * from "./ManageOrderItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports